import { csvw_url } from "../../components/config";
import workshop1 from "./config1.js";
export default {
  workshop1,
}
